import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import type { TooltipProps } from "@mui/material"
import { styled, Tooltip, tooltipClasses } from "@mui/material"

import { extraColors, theme } from "../../../utils/theme"

export const SectionContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  padding: 24,
  borderRadius: 8,
  marginTop: 16,
  background: extraColors.translucent5,
})

export const InfoIconStyled = styled(InfoOutlinedIcon)({
  height: 16,
  marginLeft: 4,
  fill: extraColors.status.navyLight,
})

export const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    ...theme.typography.small1,
    backgroundColor: extraColors.dark5,
    color: extraColors.white,
    fontFamily: theme.typography.fontFamily,
    border: `1px solid ${extraColors.dark10}`,
    borderRadius: 2,
    padding: "8px 12px",
  },
  [`& .${tooltipClasses.arrow}`]: {
    "&:before": {
      border: `1px solid ${extraColors.dark10}`,
    },
    color: extraColors.dark10,
  },
})
